
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CompanySettingsModal } from '@/components/CompanySettingsModal';

const Settings: React.FC = () => {
  const [showCompanySettings, setShowCompanySettings] = React.useState(false);
  
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6 text-white">Einstellungen</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Unternehmensdaten</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-4">Verwalten Sie Ihre Unternehmensinformationen für E-Mail-Vorlagen.</p>
            <Button onClick={() => setShowCompanySettings(true)}>
              Unternehmensdaten bearbeiten
            </Button>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader>
            <CardTitle>Konto</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-4">Verwalten Sie Ihre Kontoeinstellungen und Abonnements.</p>
            <Button variant="outline">
              Konto verwalten
            </Button>
          </CardContent>
        </Card>
      </div>
      
      {showCompanySettings && (
        <CompanySettingsModal 
          open={showCompanySettings} 
          onOpenChange={setShowCompanySettings} 
        />
      )}
    </div>
  );
};

export default Settings;
